import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionQuery } from '../state/session/session.query';
import { map, switchMap, take } from 'rxjs/operators';
import { AppConfigQuery } from '../state/app-config/app-config.query';
import { ImpersonateQuery } from '../../pages/admin/impersonate/state/impersonate.query';

@Injectable({
    providedIn: 'root'
})
export class AccessRightGuard implements CanActivate {
    constructor(
        private session: SessionQuery,
        private appConfig: AppConfigQuery,
        private impersonateQuery: ImpersonateQuery
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | boolean {
        // if new keycloak flow is used skip guard
        if (this.appConfig.get().useLatestKeycloakFlow) return true;

        return this.impersonateQuery.selectImpersonatedUser$.pipe(
            take(1),
            switchMap((impersonatedUser) => {
                const scopes$ = impersonatedUser
                    ? this.session.impersonatedUserScope$
                    : this.session.userScopes$;
                return scopes$.pipe(
                    map(
                        (scope) =>
                            Array.isArray(scope) &&
                            scope.some((s) => route.data?.accessRights?.includes(s))
                    )
                );
            })
        ) as Observable<boolean>; // Cast the entire observable chain to Observable<boolean>
    }
}
